export const contactForm = {
    requiredFieldsId: ["nom", "prenom", "societe", "email", "telephone"],
    form: null,
    init: (formId) => {
        contactForm.form = document.getElementById(formId);
        contactForm.form.addEventListener("submit", contactForm.handleSubmit);
    },
    handleSubmit: async (event) => {
        event.preventDefault();
        if (!contactForm.form) return;
        contactForm.clearErrors();
        const formData = new FormData(contactForm.form);
        const data = Object.fromEntries(formData.entries());
        const errors = [];
        contactForm.requiredFieldsId.forEach((id) => {
            if (!data[id] || data[id].trim() === "") {
                errors.push({ id, message: "Ce champ ne peut être vide" });
            }
        });
        if (data.email.trim()) {
            if (!contactForm.isValidEmail(data.email)) {
                errors.push({ id: "email", message: "Email invalide" });
            }
        }
        const formAlert = contactForm.form.querySelector(".form__submit__message");
        if (errors.length > 0) {
            errors.forEach((error) => contactForm.showFieldError(error.id, error.message));
            formAlert.innerText = "Veuillez corriger le formulaire et envoyer à nouveau";
            formAlert.classList.add("error");
        } else {
            const response = await fetch(contactForm.form.action, {
                method: contactForm.form.method,
                headers: {
                    Accept: "application/json",
                },
                body: formData,
            });
            if (response.ok) {
                formAlert.innerText =
                    "Votre demande de contact a bien été recue, nous reviendrons vers vous très prochainement";
                formAlert.classList.add("success");
                contactForm.form.reset();
            } else {
                formAlert.innerText = "Une erreur est survenue, veuillez réessayer";
                formAlert.classList.add("error");
            }
        }
        formAlert.classList.add("show");
    },

    clearErrors: () => {
        const errors = contactForm.form.querySelectorAll(".error__message");
        errors.forEach((error) => {
            error.classList.remove("show");
            error.classList.remove("not-valid");
            contactForm.form.classList.remove("form-not-valid");
            error.innerText = "";
        });
    },

    showFieldError(fieldId, message) {
        const field = contactForm.form.querySelector(`#${fieldId}`);
        const parent = field.parentElement;
        const el = parent.querySelector(".error__message");
        el.innerText = message;
        el.classList.add("show");
        field.classList.add("not-valid");
        contactForm.form.classList.add("form-not-valid");
    },
    isValidEmail(email) {
        const regexEmail = new RegExp(
            "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"
        );
        return regexEmail.test(email.trim());
    },
};
